import { Outlet, createRootRoute, createRoute, createRouter, useParams } from "@tanstack/react-router";
import { PadScreen } from "./screens/PadScreen";
import { normalizePadId } from "./shared";

function RootLayout() {
  return <Outlet />;
}

function PublicPadRoute() {
  return <PadScreen padId="public" />;
}

function SharedPadRoute() {
  const { padId } = useParams({ from: "/s/$padId" });
  const normalized = normalizePadId(padId);

  return <PadScreen padId={normalized ?? "public"} invalidPad={!normalized} />;
}

const rootRoute = createRootRoute({ component: RootLayout });

const indexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/",
  component: PublicPadRoute,
});

const sharedRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/s/$padId",
  component: SharedPadRoute,
});

const routeTree = rootRoute.addChildren([indexRoute, sharedRoute]);

export const router = createRouter({ routeTree });

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
